import React from 'react';
import { Container } from 'react-bootstrap';
import '../styles/Footer.css'
import logo from '../logo.svg';

export default function Footer () {
    return (
        <footer className='footer'>
            <Container>
                <img title='Credit: FreePik 😊' className='mb-3' src={logo} alt={logo} width='100' /><br />
                <q>Living, Learning and Leveling up my skills. Yes, it's me</q><br />
                <span>&copy; Labib Mahfuz Tonay</span>
            </Container>
        </footer>
    );
};